import React from 'react';
import {Link} from 'react-router-dom';
import {useTranslate} from 'react-redux-multilingual';
import Picture from '../cpr/Picture';
import {openScheduleVisit} from '../cpr/schedule-visit';

function HomeHero() {
    const t = useTranslate();
    return (
        <section className="cpr-hero" aria-labelledby="cpr-hero-title">
            <Picture name="arabkir-facade" priority sizes="100vw" className="cpr-hero__media"
                     alt={t('aboutBuilding')}/>
            <div className="cpr-hero__scrim" aria-hidden="true"/>
            <div className="cpr-container cpr-hero__content">
                <h1 id="cpr-hero-title" className="cpr-h1 cpr-hero__title">{t('hero_title')}</h1>
                <p className="cpr-hero__text">{t('hero_text')}</p>
                <div className="cpr-hero__actions">
                    <Link to="/arabkir" className="cpr-btn cpr-btn--on-image">{t('select_apartment')}</Link>
                    <a href="#contact" className="cpr-btn cpr-btn--ghost-on-image" onClick={openScheduleVisit}>
                        {t('schedule_a_visit')}
                    </a>
                </div>
            </div>
        </section>
    );
}

export default HomeHero;
